import React from 'react';
import { Card } from '~/components/Card';
import { MfaGoogleAuth } from '~/components/Auth';
import { ServicesContext } from '~/services';
import { useServiceSubscribe } from '~/util';
import { EditInfo, StaticInfo } from './Info';
import { EditPhone, StaticPhone } from './Phone';

export function LoginInfo() {
    const services = React.useContext(ServicesContext);
    const user = services.user.get();
    const [userPhone, setUserPhone] = React.useState(user.user_phones?.[0]);
    const [editing, setEditing] = React.useState(false);
    const [editingPhone, setEditingPhone] = React.useState(false);

    function onUserUpdate() {
        const updatedUser = services.user.get();
        setUserPhone(updatedUser.user_phones?.[0]);
    }

    useServiceSubscribe(services.user.events.userUpdated, onUserUpdate);

    return (
        <Card
            title={
                <div className="row mb-0">
                    <div className="col-8 align-self-center">Login Information</div>
                </div>
            }
        >
            {!editing ? (
                <StaticInfo edit={() => setEditing((prev) => !prev)} />
            ) : (
                <EditInfo edit={() => setEditing((prev) => !prev)} />
            )}
            <hr className="my-4" />
            <div className="h5">2-Step Verification</div>
            <MfaGoogleAuth />
            <br />
            {!editingPhone ? (
                <StaticPhone edit={() => setEditingPhone((prev) => !prev)} userPhone={userPhone} />
            ) : (
                <EditPhone
                    edit={() => setEditingPhone((prev) => !prev)}
                    userPhone={user.user_phones?.[0]}
                />
            )}
        </Card>
    );
}
